<template lang="pug">
div
  .container-listagem
    app-divider(label="Filtro:").margin-bottom
    el-card.card-container(shadow="hover")
      filtro(
        @pesquisar="pesquisar",
        @limpar="clear",
        :showOs="false",
        :showMunicipios="false",
        :configuracaoFiltro="configuracaoFiltro",
        :filtroRapido="filtroRapido"
      )
    app-divider(label="Laudos:").margin-bottom
    app-listagem(
      :has-refresh-button="true",
      :json-headers="colunas",
      :json-data="laudos",
      :totalElements="totalElements",
      :pagina="filtro.pagina",
      :filtro="filtro",
      @atualizarFiltro="atualizarFiltro",
      @updateListagem="findProcessos",
      @changePage="changePage",
      @sort="sort",
      @executar="executar"
    )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppPaginacao from '@/components/AppPaginacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/AppListagem'
import AppModalLaudo from './AppModalLaudo'
import Utils from '@/utils/utils'
import Filtro from '@/components/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {
  mixins: [
    AppNotificacao,
    BaseFiltro
  ],
  components: {
    Filtro,
    AppListagem,
    AppPaginacao,
    AppDivider,
    AppModalLaudo
  },

  data () {
    return {
      totalElements: 0,
      filtro: FILTRO_EMPTY('LAUDO_EM_ANALISE'),
      laudos: [],
      configuracaoFiltro: {
        filtroResponsavel: [],
        filtroSituacao: ['ANALISTA_DE_OCUPACAO']
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => false, ordem: 1, sortable: false, acoes: [] },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpj', ordem: 2, sortable: false, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocial', ordem: 3, sortable: false, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'situacao', ordem: 4, sortable: false, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, sortable: false, acoes: [] },
        { id: 7, titulo: 'Data de upload', propriedade: 'dataVistoria', ordem: 6, sortable: false, acoes: [] },
        {
          id: 8, titulo: 'Ações', propriedade: 'tipo', ordem: 7, sortable: false, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: () => true },
            { id: 2, nome: 'Continuar Analise', icone: 'fa-edit', codigo: 'ANALISAR_PROCESSO', ordem: 1, show: this.showContinuarAnalise }
          ]
        }
      ],
      filtroRapido: null,
      Utils,
      laudosSelecionados: [],
      laudosDto: []
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogin: 'auth/usuarioLogado'
    })
  },

  async created () {
    await this.carregaProcessos()
  },

  methods: {
    ...mapActions({
      getLaudosDto: 'diagnostico/getLaudosDto'
    }),
    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.findProcessos()
    },
    async findProcessos () {
      this.laudos = []
      const result = await this.getLaudosByFilter(this.filtro)
      if (result.content) {
        this.laudos = result.content
      }
      this.totalElements = result.totalElements
    },
    async carregaProcessos () {
      this.clearFiltro()
      await this.findProcessos()
    },
    sort (data) {
      this.isBusca = true
      this.filtro.pagina = 0
      this.filtro.ordem = data.ordenacao
      this.filtro.ordemDirecao = data.tipo
      this.findProcessos()
    },
    clear () {
      this.clearFiltro()
      this.carregaProcessos()
    },
    clearFiltro () {
      this.filtro = FILTRO_EMPTY('LAUDO_EM_ANALISE')
    },
    search (param) {
      this.filtro.campoSimples = param
      this.filtro.simplificado = true
      this.filtro.pagina = 0
      this.findProcessos()
    },
    async pesquisar (filtro) {
      this.filtro = filtro
      this.filtro.caixa = 'LAUDO_EM_ANALISE'
      this.filtro.simplificado = false
      this.filtro.pagina = 0
      await this.findProcessos()
    },
    atualizarFiltro () {
      this.findProcessos()
    },
    selectItems (itens) {
      this.laudosSelecionados = itens
    },
    async GERAR_LAUDO () {
      if (this.laudosSelecionados.length > 0) {
        if (!this.laudosSelecionados[0].id) {
          this.laudosSelecionados = this.laudosSelecionados.map(l => ({ id: l }))
        }
        this.laudosDto = await this.getLaudosDto(this.laudosSelecionados.map(l => l.id))
        this.showModal = true
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          this.$messages.SELECIONA_MINIMO_PROCESSO)
      }
    },
    async ANALISAR_PROCESSO (_this, { item }) {
      this.$router.push({ name: 'vistoria-remota/analisar', params: { id: item.id } })
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      window.open(`?protocolo=${item.protocolo}/#/visualizarProcesso`, `Visualizar processo ${item.numeroProcesso}`, 'height=500,width=800,top=25%, left=50%')
    },
    showContinuarAnalise (dado) {
      return !['AGUARDANDO_GERACAO', 'FINALIZADO'].includes(dado.codigoSituacao)
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-processos {
    flex: 1;
    padding: 20px;
  }

  .processos-header {
    display: inline-flex;
    align-items: start;
    padding: 10px 0;
  }

  .processos-main {
    padding: 10px 0;
  }

  .busca-processos {
    padding: 10px 0;
  }

  .listagem-processos {
    padding: 10px 0;
  }

  .container-listagem {
    background-color: #f8f8f8;
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    padding: 0.2% 1.5%;
    gap: 4%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    h3 {
      font-weight: bold;
    }

    .container-switch {
      justify-content: center;
      gap: 2%;
      font-weight: bold;
      height: 10vh;
      align-items: center;
      margin-top: 3%;
    }

    #export-button {
      right: 0;
      position: absolute;
    }
  }

  .margin-bottom {
    margin-bottom: 10px;
  }

  .card-container {
    margin: 20px;
    border-radius: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/diagnostico/ListagemEmAnalise.vue